import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiUrl } from '../utility/api-config';

@Injectable({
  providedIn: "root",
})
export class AuthHeaderInterceptorService implements HttpInterceptor {
  /**
   * @method intercept - Identifies and handles a given HTTP request.
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    let accesToken = '';
    if (request.url.includes(ApiUrl)) {
      accesToken = localStorage.getItem("JWTtoken")
        ? "Bearer " + localStorage.getItem("JWTtoken")
        : "null";
      } else {
        accesToken = localStorage.getItem("PKCEToken")
        ? "Bearer " + localStorage.getItem("PKCEToken")
        : "null";
      }
      const myAuthToken = accesToken;
      const authReq = request.clone({
        setHeaders: { Authorization: myAuthToken },
      });
    return next.handle(authReq);
  }
}
